import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  GET_TALKING_SKILL_LIST,
  SET_TALKING_SKILL_PAGE_STATUS,
  SET_TALKING_SKILL_CONFIG_MODAL_DATA,
  CONFIG_TALKING_SKILL,
  GET_TALKING_SKILL_AI_APP_OPTIONS,
  GET_TALKING_SKILL_APP_CHANNEL_OPTIONS,
  GET_TASKING_SKILL_YUNWEN_CHANNELS,
  GET_TASKING_SKILL_YUNWEN_SCENES
} = SYSTEMSETTING;
// 通用前缀
const url = '/robot';

const actions = {
  // 系统设置-话术列表-列表
  getTableList(data) {
    return {
      type: GET_TALKING_SKILL_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/strategy/list`,
          data,
        },
      },
    };
  },
  // 系统设置-话术列表-设置pageNum与pageSize
  setPageStatus(data) {
    return {
      type: SET_TALKING_SKILL_PAGE_STATUS,
      data,
    };
  },
  // 系统设置-话术列表-获取配置弹框的数据
  setConfigModalData(data) {
    return {
      type: SET_TALKING_SKILL_CONFIG_MODAL_DATA,
      data,
    };
  },
  // 系统设置-话术列表-配置/添加
  configTalkingSkill(data) {
    return {
      type: CONFIG_TALKING_SKILL,
      payload: {
        request: {
          method: 'post',
          url: `${url}/strategy/insert`,
          data,
        },
      },
    };
  },
  // 系统设置-话术列表-配置话术-ai应用下拉框
  getAiAppOptions() {
    return {
      type: GET_TALKING_SKILL_AI_APP_OPTIONS,
      payload: {
        request: {
          method: 'get',
          url: `/robot/strategy/application`,
        },
      },
    };
  },
  // 系统设置-话术列表-配置话术-应用渠道下拉框
  getAppChannelOptions(id) {
    return {
      type: GET_TALKING_SKILL_APP_CHANNEL_OPTIONS,
      payload: {
        request: {
          method: 'get',
          url: `robot/strategy/channel?applicationId=${id}`,
        },
      },
    };
  },
  // 获取云问渠道列表
  getYunwenChannels() {
    return {
      type: GET_TASKING_SKILL_YUNWEN_CHANNELS,
      payload: {
        request: {
          method: 'get',
          url: `robot/strategy/yw/channels`,
        },
      },
    };
  },
  // 获取云问场景列表
  getYunwenScenes() {
    return {
      type: GET_TASKING_SKILL_YUNWEN_SCENES,
      payload: {
        request: {
          method: 'get',
          url: `robot/strategy/yw/scenes`,
        },
      },
    };
  }
};

export default actions;
